<template>
	<div>
		<div class="modal fade" id="modal-announcement" tabindex="-1" role="dialog"
		     aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static">
			<div class="modal-dialog modal-lg modal-dialog-centered m-0" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title text-center w-100" id="exampleModalLongTitle">{{ title }}</h5>
					</div>
					<div class="modal-body overflow-auto">
						<slot></slot>
					</div>
					<div class="modal-footer" :class="{'d-flex justify-content-center': !isMobile}">
						<SOButton
							v-if="showBtnSecondary"
							class="m-0"
							:class="{'p-r-12': !isMobile}"
							:outline="true"
							:text="labelBtnSecondary"
							:id="'btn-secondary'"
							:full="isMobile"
							@action="actionSecondary"
						/>
						<SOButton
							v-if="showBtnPrimary"
							class="m-0"
							:class="{isMobile}"
							:primary="true"
							:text="labelBtnPrimary"
							:id="'btn-secondary'"
							:full="isMobile"
							@action="actionPrimary"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "SOModalAnnouncement",
	components: {
		SOButton,
	},
	props: {
		title: {
			type: String,
			default: ""
		},
		showBtnPrimary: {
			type: Boolean,
			default: true,
		},
		showBtnSecondary: {
			type: Boolean,
			default: false,
		},
		labelBtnPrimary: {
			type: String,
			default: ""
		},
		labelBtnSecondary: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			isMobile: window.innerWidth < 768
		}
	},
	mounted() {
		$("#modal-announcement").modal("show")
	},
	methods: {
		actionPrimary() {
			this.close()
			setTimeout(() => {
				this.$emit("action-primary")
			}, 500)
		},
		actionSecondary() {
			this.$emit('action-secondary')
			this.close()
		},
		close() {
			setTimeout(function () {
				$("#modal-announcement").modal("hide")
			}, 300)
		}
	},
	beforeDestroy() {
		$(".modal-backdrop").remove()
		$("body").removeClass("modal-open")
	},
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
	.modal-content {
		height: calc(100vh - 52px);
	}

	.modal-dialog-centered {
		align-items: flex-end;
		height: 100%;
	}

	.btn-primary {
		width: 100% !important;
	}

	.btn-outline-primary {
		width: 100% !important;
	}
}

@media screen and (min-width: 768px) {
	.modal-open .modal {
		left: calc((100% - (768px + 16px)) / 2) !important;
		max-width: none;
	}

	.modal-body {
		max-height: 500px;
	}

	.modal-content {
		border-bottom-left-radius: 10px !important;
		border-bottom-right-radius: 10px !important;
	}
}
</style>